<div class="flex-column flex-fill">
  <div class="ms-auto mt-2 mb-2">
    <button type="button" kendoButton [buttonLoading]="loading" themeColor="primary" [svgIcon]="icons.refresh" (click)="loadData()" style="float: inherit;">{{ loading ? 'Loading...' : 'Refresh' }}</button>
  </div>
  <div class="container-fluid">
    <kendo-stockchart #chart style="height: 100%;" [chartArea]=" {margin:0, border: {width: 0}}">
      <kendo-chart-title text="Capacity Vs Production Forecast ({{forecastId}})" [margin]="0" [border]="{width:0}">
      </kendo-chart-title>
      <kendo-chart-legend [title]="legendTitle" position="right" [labels]="{font: '12px Arial'}">
      </kendo-chart-legend>
      <kendo-chart-series>
        @for (item of series; track item) {
          <kendo-chart-series-item type="line" [name]="item.name" [color]="item.color" [data]="item.data" field="value" categoryField="date" [style]="'smooth'" [markers]="{ visible: false }">
          </kendo-chart-series-item>
        }
      </kendo-chart-series>
      <kendo-chart-category-axis>
        <kendo-chart-category-axis-item name="categoryAxis" [baseUnit]="baseUnit" [maxDivisions]="30">
        </kendo-chart-category-axis-item>
      </kendo-chart-category-axis>

      <kendo-chart-navigator [pane]="{margin: 0,padding:0}">
        <kendo-chart-navigator-select [from]="minDate" [to]="maxDate">
        </kendo-chart-navigator-select>
        <kendo-chart-navigator-series>
          <kendo-chart-navigator-series-item missingValues="interpolate" color="#C4C4C4" type="area" [data]="categories" categoryField="date">
          </kendo-chart-navigator-series-item>
        </kendo-chart-navigator-series>
      </kendo-chart-navigator>

      <kendo-chart-value-axis>
        <kendo-chart-value-axis-item [title]="" [labels]="{ format: '{0:n0}' }">
        </kendo-chart-value-axis-item>
      </kendo-chart-value-axis>
    </kendo-stockchart>
  </div>
</div>